export default __webpack_public_path__ + "9148013f0a71483a6d103aa294bf9b7a.png";